import { useParams } from "react-router-dom";
import BunnyPlayer from './BunnyPlayer';

const libraries = {
  "ankido-cdn.educationforalliraqis.com/corrsy-cdn.becdn.net": "261409",
  "baghdad-cdn.becdn.net": "261494",
  "xy-cdn.becdn.net": "261537",
  "alayn-efai.becdn.net": "278856",
  "albaroudi-cdn.becdn.net": "279084",
  "alwid-cdn.becdn.net": "330718",
  "wlarchive-efai.becdn.net": "377008",
  "uniedtech-efai.becdn.net": "392184",
  "qusayaltamimi-efai.becdn.net": "392191",
  "alqalam-efai.becdn.net": "392206",
  "nooneducation-efai.becdn.net": "392207",
  "alnakheel-efai.becdn.net": "392208",
  "alamal-efai.becdn.net": "392209",
  "ankido-cdn.educationforalliraqis.com/ankido-efai.becdn.net": "392210",
  "alialkhakani-efai.becdn.net": "392211",
  "royalschools-efai.becdn.net": "392212",
  "alhuda-efai.becdn.net": "392217",
  "staging-efai.becdn.net": "392547",
  "iraqteachers-efai.becdn.net": "397076",
  "hatra-efai.becdn.net": "401686",
  "alazal-efai.becdn.net": "401728",
  "misaba-efai.becdn.net": "403689",
  "azupedia-efai.becdn.net": "403746",
  "todowiththo-efai.becdn.net": "403763",
  "ebdaaalrawad-efai.becdn.net": "403918",
  "fedshiplatform-efai.becdn.net": "406444",
  "basmaamal-efai.becdn.net": "409209",
  "almasremotelearning-efai.becdn.net": "409417",
  "almas-efai.becdn.net": "409418",
  "almasremote-efai.becdn.net": "409420",
  "alfqma-efai.becdn.net": "410355",
  "supercelliq-efai.becdn.net": "412233",
  "haroof-efai.becdn.net": "413415",
  "alemplus-efai.becdn.net": "415210",
  "tarkeys-efai.becdn.net": "420490",
  "almasinstitute-efai.becdn.net": "420831",
  "buratha-efai.becdn.net": "421344",
  "larsa-efai.becdn.net": "423886",
  "anwaralkafeel-efai.becdn.net": "423895",
  "athar-efai.becdn.net": "428891",
  "ammarzuheiry-efai.becdn.net": "430681",
  "almansour-efai.becdn.net": "430689",
  "almanar-efai.becdn.net": "432277",
  "zamam-efai.becdn.net": "460263",
  "chemmessenger-efai.becdn.net": "461069",
  "ghanimqaissy-efai.becdn.net": "461135",
  "letussuccess-efai.becdn.net": "461138",
  "langunlimited-efai.becdn.net": "461143",
  "aromatic-efai.becdn.net": "461163",
  "threesixnine-efai.becdn.net": "461399",
  "mohammedali-efai.becdn.net": "461407",
  "raadsaleem-efai.becdn.net": "461879",
  "munthermahmood-efai.becdn.net": "461880",
  "seboeh-efai.becdn.net": "462347",
  "mohamedkilabi-efai.becdn.net": "462348",
  "eulersameer-efai.becdn.net": "467103",
  "juniorspace-efai.becdn.net": "467105",
  "finnishhouse-efai.becdn.net": "467106",
  "examnettz-efai.becdn.net": "467429",
  "alaq-baghdad-efai.becdn.net": "471453",
  "alraqeza-efai.becdn.net": "473297",
  "alaqschools-efai.becdn.net": "473300",
  "sindbadplatform-efai.becdn.net": "473556",
  "alfarisacademy-efai.becdn.net": "476504",
  "futuremakers-efai.becdn.net": "476560",
  "ahmedaljareesy-efai.becdn.net": "477199",
  "dahabacademy-efai.becdn.net": "477200",
  "lebaneseschool-efai.becdn.net": "479065",
  "xy2-efai.becdn.net": "479247",
  "taheelacademy-efai.becdn.net": "480951",
  "maxacademy-efai.becdn.net": "488734",
  "unitedvision-efai.becdn.net": "488910",
  "klayacademy-efai.becdn.net": "488943",
  "empireeducation-efai.becdn.net": "488944",
  "iqraasmart-efai.becdn.net": "489839",
  "manassaty-efai.becdn.net": "491685",
  "knowledgeinst-efai.becdn.net": "491689",
  "arrakacademy-efai.becdn.net": "497327",
  "tamayuzacademy-efai.becdn.net": "497982",
  "murttest2-efai.becdn.net": "498358",
  "murttest3-efai.becdn.net": "498360",
  "rezanacademy-efai.becdn.net": "501426",
  "larsaelectronic-efai.becdn.net": "508986",
  "jeelplatform-efai.becdn.net": "509271",
  "zacademy-efai.becdn.net": "550810",
  "benzinacademy-efai.becdn.net": "551262",
  "MEDACEplatform-efai.becdn.net": "552169",
  "nabuacademy-efai.becdn.net": "552207",
  "ahmedsal-efai.becdn.net": "553051",
  "medaceplatform-efai.becdn.net": "553832",
  "balyacademy-efai.becdn.net": "565331",
  "teacheracademy-efai.becdn.net": "578410",
  "edrevolution-efai.becdn.net": "587938",
  "alfarazdaq-efai.becdn.net": "604185",
  "musayar-efai.becdn.net": "604697",
  "twoaldayni-efai.becdn.net": "605602",
  "basmaya-efai.becdn.net": "607301",
  "encrypted-efai.becdn.net": "611657",
};

export default function Bunny() {
  const { cdnHostname, bunnyID } = useParams();

  if (cdnHostname in libraries) {
    return (
      <iframe
        title="video"
        src={`https://iframe.mediadelivery.net/embed/${libraries[cdnHostname]}/${bunnyID}`}
      />
    );
  }

  return <BunnyPlayer cdnHostname={cdnHostname} bunnyID={bunnyID} v={0.1} />
}